import { render } from "./DashboardBase.vue?vue&type=template&id=14a480d6"
import script from "./DashboardBase.vue?vue&type=script&lang=js"
export * from "./DashboardBase.vue?vue&type=script&lang=js"

import "./DashboardBase.vue?vue&type=style&index=0&id=14a480d6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__